import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDebounce } from '@/hooks/useDebounce';

const parseDate = (value?: string | null): Date | null => {
  if (!value) return null;

  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);

  if (!m) return null;

  const y = Number(m[1]),
    mm = Number(m[2]),
    dd = Number(m[3]);

  const d = new Date(y, mm - 1, dd);

  return d.getFullYear() === y && d.getMonth() === mm - 1 && d.getDate() === dd
    ? d
    : null;
};

export type SearchParamsState = {
  guestsRaw: string | null;
  checkinRaw: string | null;
  checkoutRaw: string | null;
  guests: number | null;
  checkInDate: Date | null;
  checkOutDate: Date | null;
};

export const useSearchParamsState = (debounceMs = 300): SearchParamsState => {
  const [sp] = useSearchParams();

  const guestsRaw = sp.get('guests');
  const checkinRaw = sp.get('checkin');
  const checkoutRaw = sp.get('checkout');

  const dGuests = useDebounce(guestsRaw, debounceMs);
  const dCheckin = useDebounce(checkinRaw, debounceMs);
  const dCheckout = useDebounce(checkoutRaw, debounceMs);

  return useMemo(() => {
    const gi = dGuests !== null ? Number(dGuests) : null;
    return {
      guestsRaw,
      checkinRaw,
      checkoutRaw,
      guests: Number.isFinite(gi) ? (gi as number) : null,
      checkInDate: dCheckin ? parseDate(dCheckin) : null,
      checkOutDate: dCheckout ? parseDate(dCheckout) : null,
    };
  }, [guestsRaw, checkinRaw, checkoutRaw, dGuests, dCheckin, dCheckout]);
};
